import React, { Component } from 'react';

// Circulante uruguayo. El orden es el que se usa al contar: de mayor a menor.
const BILLETES = [2000, 1000, 500, 200, 100, 50, 20];
const MONEDAS = [10, 5, 2, 1];

/**
 * Ayuda para contar el cajón por denominación (docs/spec-caja.md).
 *
 * Es OPCIONAL: el campo de "dinero contado" se puede seguir tipeando a mano. Quien prefiera contar
 * por pilas abre esto, pone cuántos billetes y monedas hay de cada uno, y el total va al campo
 * solo — que es donde se equivocaba la cuenta hecha de cabeza.
 *
 * No se persiste: es una calculadora, no un dato del arqueo. Lo que se guarda es el total contado.
 */
class CashCountCalculator extends Component {

    state = { abierta: false, cantidades: {} };

    money = (n) => `$${Number(n || 0).toLocaleString('de-DE')}`;

    total = (cantidades = this.state.cantidades) =>
        [...BILLETES, ...MONEDAS].reduce((t, d) => t + d * (Number(cantidades[d]) || 0), 0);

    cambiar = (denominacion, valor) => {
        // Sólo dígitos: una cantidad de billetes no tiene decimales ni signo.
        const limpio = String(valor).replace(/[^\d]/g, '');
        const cantidades = { ...this.state.cantidades, [denominacion]: limpio };
        this.setState({ cantidades });
        this.props.onTotal(this.total(cantidades));
    };

    limpiar = () => {
        this.setState({ cantidades: {} });
        this.props.onTotal(0);
    };

    alternar = () => {
        const abierta = !this.state.abierta;
        this.setState({ abierta });
        // Al cerrarla no se toca el campo: si contaron con la calculadora, ese total queda.
    };

    fila = (denominacion) => {
        const cantidad = this.state.cantidades[denominacion] || '';
        const subtotal = denominacion * (Number(cantidad) || 0);

        return (
            <div className="d-flex align-items-center mb-1" key={denominacion}>
                <span className="text-muted" style={{ width: 58, fontSize: 13, textAlign: 'right', paddingRight: 8 }}>
                    ${denominacion}
                </span>
                <span className="text-muted" style={{ paddingRight: 6 }}>×</span>
                <input
                    type="text"
                    inputMode="numeric"
                    className="form-control form-control-sm"
                    style={{ width: 64 }}
                    value={cantidad}
                    onChange={(e) => this.cambiar(denominacion, e.target.value)}
                    placeholder="0"
                    aria-label={`Cantidad de ${denominacion}`}
                />
                <span
                    className={subtotal ? '' : 'text-muted'}
                    style={{ flex: 1, textAlign: 'right', fontSize: 13, fontVariantNumeric: 'tabular-nums' }}
                >
                    {subtotal ? this.money(subtotal) : '—'}
                </span>
            </div>
        );
    };

    render() {
        const total = this.total();

        return (
            <div className="mb-3">
                <button
                    type="button"
                    className="btn btn-link p-0"
                    style={{ fontSize: 13 }}
                    onClick={this.alternar}
                >
                    {this.state.abierta ? '− Ocultar la calculadora' : '+ Contar por billetes y monedas'}
                </button>

                {this.state.abierta && (
                    <div className="mt-2 p-3" style={{ border: '1px solid #dde2e7', borderRadius: 6 }}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="text-muted mb-2" style={{ fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase' }}>
                                    Billetes
                                </div>
                                {BILLETES.map(this.fila)}
                            </div>
                            <div className="col-md-6">
                                <div className="text-muted mb-2" style={{ fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase' }}>
                                    Monedas
                                </div>
                                {MONEDAS.map(this.fila)}
                            </div>
                        </div>

                        <div
                            className="d-flex justify-content-between align-items-baseline mt-2 pt-2"
                            style={{ borderTop: '1px solid #dde2e7', fontWeight: 600 }}
                        >
                            <span>Total contado</span>
                            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{this.money(total)}</span>
                        </div>

                        <button type="button" className="btn btn-link p-0 mt-1" style={{ fontSize: 12 }} onClick={this.limpiar}>
                            Empezar de nuevo
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default CashCountCalculator;
